import { RouteComponentProps, Switch } from 'react-router-dom';

import AuthenticatedPrivateRoute from '../../../AuthenticatedPrivateRoute';
import { MatchParam } from '../../../common/types';
import EC2Recommendation from './ec2-recommendations/EC2Recommendation';
import EC2Cost from './EC2Cost';
import ITLaborSupportCost from './ITLaborSupportCost';
import RDSRecommendation from './rds-recommendations/RDSRecommendation';
import RDSCost from './RDSCost';
import AWSStorageAndNetworkCost from './storage-network-cost/AWSStorageNetworkCost';

type AwsPagesProps = RouteComponentProps<MatchParam>;

function AwsPages(props: AwsPagesProps) {
    const { path } = props.match;

    return (
        <Switch>
            <AuthenticatedPrivateRoute path={`${path}/server-recommendations`} component={EC2Recommendation}/>
            <AuthenticatedPrivateRoute path={`${path}/server-costs`} component={EC2Cost}/>
            <AuthenticatedPrivateRoute path={`${path}/database-recommendations`} component={RDSRecommendation}/>
            <AuthenticatedPrivateRoute path={`${path}/database-costs`} component={RDSCost}/>
            <AuthenticatedPrivateRoute path={`${path}/storage-network-costs`} component={AWSStorageAndNetworkCost}/>
            <AuthenticatedPrivateRoute path={`${path}/it-labor-support-costs`} component={ITLaborSupportCost}/>  
        </Switch>
    );
}

export default AwsPages;
